import React, { useState,useEffect } from 'react'
import { RowListProducts } from '../../../../../listing/components/list'
import {  RowItemSkelton } from '../../../../../listing/components/list/row-item'

export default props => {
    const {
        filterData,
        sensors,
        products,
        request,
        loading,
        finished,
        giftInfo,
        isAddOn,
        deleteItemHandle,
        afterAddToCart,
        beforeAddToCart
    } = props
    const [firstInit, setFirstInit] = useState(true)
    useEffect(()=>{
        if(products || finished){
            setFirstInit(false)
        }
    }, [products])

    return <div>
        {
            firstInit ?
            <React.Fragment>
                {
                    [1,2,3,4,5,6,7].map((item, index) => (
                        <RowItemSkelton/>
                    ))
                }
            </React.Fragment>:
            <RowListProducts
                sensors={sensors}
                products={products}
                request={request}
                loading={loading}
                finished={finished}
                giftInfo={giftInfo}
                isAddOn={isAddOn}
                deleteItemHandle={deleteItemHandle}
                afterAddToCart={afterAddToCart}
                beforeAddToCart={beforeAddToCart}
            />
        }
    </div>
}

export const FilterProductsNoSensors = props => {
    const {
        filterData,
        sensors,
        products,
        request,
        loading,
        finished,
        giftInfo
    } = props

    const [firstInit, setFirstInit] = useState(true)
    useEffect(()=>{
        if(products || finished){
            setFirstInit(false)
        }
    }, [products])

    return <div>
        {
            firstInit ?
            <React.Fragment>
                {
                    [1,2,3,4,5,6,7].map((item, index) => (
                        <RowItemSkelton/>
                    ))
                }
            </React.Fragment>:
            <RowListProducts
                sensors={sensors}
                products={products}
                request={request}
                loading={loading}
                finished={finished}
                giftInfo={giftInfo}
                sensorOnlyClick={true}
            />
        }
    </div>
}